import './LandingPage.css';


export default function LandingPage() {
  return (
        <>
           {/* HERO */}
        <section className="sil-hero">
        <div className="sil-hero-bg"></div>
        <div className="sil-hero-inner">
          <div className="sil-hero-left">
            <div className="sil-badge">Building Smart Products</div>
            <h1>Intelligence,<br/><span>Woven in Silicon.</span></h1>
            <p>Silwren™ builds autonomous <b>Smart Agents</b>, <b>Computer Vision</b> products and <b>Robots</b>. We also provide <b>tailored products</b> based on Customer's need. </p>
            {/* <div className="sil-hero-actions">
              <button className="sil-btn-primary">Request Demo →</button>
              <button className="sil-btn-ghost">Explore Research</button>
            </div> */}
            {/* <div className="sil-trusted">
              <span>Trusted by researchers building next-gen AI</span>
            </div> */}
          </div>

          <div className="sil-hero-right">
            <div className="sil-glass-card main">
              <div className="sil-glass-header">
                <div className="dot"></div><div className="dot"></div><div className="dot"></div>
                <span>silwren.core • live</span>
              </div>
              <div className="sil-nodes">
                <div className="sil-node center">AI Agents</div>
                <div className="sil-line"></div>
                <div className="sil-node-row">
                  <div className="sil-node small"><span>👁️</span> Computer<br/>Vision</div>
                  <div className="sil-node small"><span>🤖</span> Robotics<br/>Control</div>
                </div>
                <div className="sil-node-row">
                  <div className="sil-node small"><span>🧠</span> Smart<br/>Agents</div>
                  <div className="sil-node small"><span>📊</span> Tailored<br/>Products</div>
                </div>
              </div>
            </div>
            <div className="sil-float-card f1"><b></b> Smart Products</div>
            {/* <div className="sil-float-card f2"><b></b> Smart Products</div> */}
            <div className="sil-float-card f3"><b>⟡</b> Commutative Invariant</div>
          </div>
        </div>
      </section>

      {/* PILLARS */}
      <section className="sil-pillars" id="agents">
        <div className="sil-section-inner">
          <h2>Three Pillars of Silwren</h2>
          <p className="sil-sub">From perception to action — a unified stack</p>
          <div className="sil-pillar-grid">
            <div className="sil-pillar">
              <div className="sil-icon">🧠</div>
              <h3>Smart Agents</h3>
              <p>Autonomous agents that reason, plan and act across enterprise workflows. Context-aware, tool-using, self-correcting.</p>
              <ul><li>Multi-step task planning</li><li>Tool & API orchestration</li><li>Long-term memory</li></ul>
            </div>
            <div className="sil-pillar featured">
              <div className="sil-icon">👁️</div>
              <h3>Computer Vision</h3>
              <p>Our novel Computer Vision architecture where operations commute — delivering invariant, efficient, and interpretable vision.</p>
              <ul><li>Order-invariant perception</li><li>70% less compute</li><li>Interpretable features</li></ul>
            </div>
            <div className="sil-pillar">
              <div className="sil-icon">🦾</div>
              <h3>Robotics</h3>
              <p>Bridging pixels to action with real-time vision-driven control. Low-latency inference for manipulation & navigation.</p>
              <ul><li>Smart Robots</li><li>Vision-to-action</li><li>Help in daily tasks</li></ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="sil-cta">
        <div className="sil-cta-card">
          <h2>Ready to weave intelligence into your product?</h2>
          <p>Join early design partners building with Silwren™</p>
          <button className="sil-btn-primary white" >Talk to Us</button>
          {/* <button className="sil-btn-primary white" onClick={handleClick}>Talk to Us</button> */}
        </div>
      </section>
    </>
  );
}